export const MFE_POINTER_CLASS_NAME = 'contract-proposal-mfe-root-pointer';
